import { lockPlan, unlockPlan } from "src/engine/repositories/lockPlans"

const toggleLock = params => {
  const { planUuids, isLocked, toggle } = params
  const lockRequest = isLocked ? unlockPlan : lockPlan

  lockRequest([planUuids])
    .then(() => {
      toggle()
    })
    .catch(error => error)
}

export default toggleLock
